// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8688":"29efc0fa","9335":"5b55fed5"}[chunkId] + ".chunk.css";
};